import React from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Col, Layout, Menu, Row } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import Login from '../../Login'
import { userActions } from '../../../store/actions/user'
import './index.css'
import logo from './logo.svg'
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom";

function Header() {
    let navigate = useNavigate();
    const { user } = useSelector((state) => state.userReducer)
    const { t } = useTranslation(['common', 'layout'])
    const dispatch = useDispatch()

    const logout = () => {
        dispatch(userActions.logout(navigate))
        const iframe = document.getElementById("iframe")
        iframe?.contentWindow?.postMessage({
            action: 'clearToken'
        }, "*")
    }

    const refreshUserData = () => {
        dispatch(userActions.refreshUserData({}))
    }

    const items = [
        {
            key: "1",
            label: <a className="nav-link" href="http://gosstroyportal.by/">
                <h3>{t('layout:services')}</h3>
            </a>
        },
        {
            key: "2",
            label: <a className="nav-link" href="http://gosstroyportal.by/">
                <h3>{t('layout:subsections')}</h3>
            </a>
        },
        {
            key: "3",
            label: <a className="nav-link" href="/help">
                <h3>{t('layout:help')}</h3>
            </a>
        },
        {
            key: "4",
            label: <a className="nav-link" href="http://gosstroyportal.by/">
                <h3>{t('layout:contacts')}</h3>
            </a>
        },
        {
            key: "5",
            label: <div className="nav-link" to="#">
                <h3>
                    {user.userName ?? <UserOutlined />}
                </h3>
            </div>,
            children: user.userName ? [
                {
                    key: "6",
                    label:
                        <Link
                            className="nav-link none-color-item-focus layout-header-submenu-menu-item"
                            to="/account"
                        >
                            {t('common:personalCabinet')}
                        </Link>
                },
                {
                    key: "7",
                    label:
                        <Link
                            className="nav-link none-color-item-focus layout-header-submenu-menu-item"
                            to=""
                            onClick={() => logout()}
                        >
                            {t('layout:logOut')}
                        </Link>
                }] :
                [{
                    key: "6",
                    label: <a
                        className="nav-link none-color-item-focus layout-header-submenu-menu-item"
                        href="http://gosstroyportal.by/registration"
                    >
                        {t('layout:registration')}
                    </a>
                },
                {
                    key: "7",
                    label: <Login navigate={navigate} />
                }]
        }
    ]

    return (
        <Layout.Header className="layout-header">
            <div
                id="loginToken"
                style={{ display: "none" }}
                onClick={() => refreshUserData()}
            />
            <Row
                align="middle"
                className="layout-header-row"
            >
                <Col
                    md={2}
                    sm={3}
                    xl={1}
                    xs={3}
                >
                    <Link to="/">
                        <img
                            alt="Логотип"
                            className="layout-header-logo"
                            src={logo}
                        />
                    </Link>
                </Col>
                <Col
                    className="layout-header-high-col"
                    md={3}
                    sm={2}
                    xl={3}
                    xs={4}
                >
                    <Link
                        className="nav-link"
                        to="/"
                    >
                        <h3 className="scp-title">
                            ГосСтройПортал
                        </h3>
                    </Link>
                </Col>
                <Col
                    className="layout-header-high-col"
                    md={13}
                    offset={6}
                    sm={13}
                    xl={14}
                    xs={11}
                >
                    <Menu
                        className="layout-header-menu none-color-item-focus"
                        mode="horizontal"
                        theme="light"
                        items={items}
                    />
                </Col>
            </Row>
        </Layout.Header>
    )
}

export default Header
